import { SVGProps } from 'react';

export const FileIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 -13 124 195"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M87.5 56.5H36.5" stroke="#009684" strokeWidth="14" strokeLinecap="round" />
      <path d="M87.5 92.5H36.5" stroke="#009684" strokeWidth="14" strokeLinecap="round" />
      <path d="M87.5 128.5H36.5" stroke="#009684" strokeWidth="14" strokeLinecap="round" />
      <path
        d="M27 162C15.9543 162 7 153.046 7 142L7 50.11C7 44.909 9.02604 39.9126 12.6484 36.1805L23.5 25L35.1099 13.0584C38.8755 9.18522 44.0478 7 49.4498 7H97C108.046 7 117 15.9543 117 27L117 142C117 153.046 108.046 162 97 162H27Z"
        stroke="#009684"
        strokeWidth="14"
      />
    </svg>
  );
};
